import { MdFoodBank } from 'react-icons/md';

//Firestore util
import Recommend from './Recommend';
import EditRecommend from './Editor/EditRecommend';

const Recommends = (props) =>{

    return (
        <div className='fitHeight'>
            <div className='title tx-white'>Recomendaciones</div>
            <div className='ContentContainer mt-2 bg-rounded bg-container'>
                <div className='Toolbar'>
                    <div className='d-inline-block d-flex flex-center ml-2'>
                        <button onClick={() => props.callback.showPopup('Nueva Recomendacion', <EditRecommend restaurantList={props.restaurantList} eDB={props.eDB} storage={props.storage} close={props.callback.closePopup} new/>)} className='cbtn-md-add d-inline-block mx-1'>
                            <MdFoodBank size='1rem' pointerEvents='none' />
                        </button><span className='btn-label tx-white'>Agregar Recomendacion</span>
                    </div>
                </div>
                
                <div className='RecommendContainer mt-2'>
                    {
                        
                        props.recommendList.map((rec) => {
                            return <Recommend key={rec.id} id={rec.id} data={rec} callback={props.callback} eDB={props.eDB} storage={props.storage} router={props.router} restaurantList={props.restaurantList} />;
                        })
                    }                    
                </div>
            </div>
        </div>
    );

}

export default Recommends;